import Cookies from 'js-cookie';
import { sendEvent } from '../../../helpers/analytics';

const COOKIE_NAME = 'preferred_currency';
const SCOPED_SELECTOR = '[data-currency-scoped]';
const TOGGLE_CHIP_SELECTOR = 'input[name="currency_switcher"]';
const CHECKBOX_SELECTOR = 'input[name="currency_switcher_checkbox"]';
const EXPIRES = 30;
export const CURRENCY_USD = 'usd';
export const CURRENCY_UAH = 'uah';

export const getIsPreferredCurrencyUsd = () => {
  return Cookies.get(COOKIE_NAME) === CURRENCY_USD;
}

class CurrencySwitcher {
  constructor(isToggleChip = true, options = {}) {
    this.isToggleChip = isToggleChip;
    this.options = options;

   const root = options.root || document;
    const filterInputs = (nodes) =>
      options.root ? nodes : nodes.filter((node) => !node.closest(SCOPED_SELECTOR));

    this.toggleChipInputs = filterInputs([...root.querySelectorAll(TOGGLE_CHIP_SELECTOR)]);
    this.checkboxSwitchers = filterInputs([...root.querySelectorAll(CHECKBOX_SELECTOR)]);
    const inputs = this.isToggleChip ? this.toggleChipInputs : this.checkboxSwitchers;

    if (!inputs.length) return;

    inputs?.forEach((input) => {
      input.addEventListener('change', (event) => {
        let currentCurrency;
        if (this.isToggleChip) {
          currentCurrency = event.target.value;
        } else {
          currentCurrency = event.target.checked ? CURRENCY_USD : CURRENCY_UAH;
        }

        sendEvent(window.eventCategory, 'currency_switcher', `${currentCurrency}_click`)

        this.updateTriggers(currentCurrency);
        this.switchCurrency(currentCurrency);
      });
    })

    this.switchCurrency(Cookies.get(COOKIE_NAME), false);

    if (this.options.onMount) this.options.onMount(Cookies.get(COOKIE_NAME));
  }

  switchCurrency(currency, triggerOnChange = true) {
    switch (currency) {
      case CURRENCY_UAH:
        this.toUAH(triggerOnChange);
        Cookies.set(COOKIE_NAME, CURRENCY_UAH, {
          domain: window.commonCookieDomain,
          expires: EXPIRES,
        });
        break;
      case CURRENCY_USD:
        this.toUSD(triggerOnChange);
        Cookies.set(COOKIE_NAME, CURRENCY_USD, {
          domain: window.commonCookieDomain,
          expires: EXPIRES,
        });
        break;
    }
  }

  setCurrencyNodes() {
    this.usd = Array.from(document.querySelectorAll('[data-currency="usd"]'));
    this.uah = Array.from(document.querySelectorAll('[data-currency="uah"]'));
  }

  toUSD(triggerOnChange) {
    this.setCurrencyNodes();
    this.usd.forEach((e) => e.classList.remove('hidden'));
    this.uah.forEach((e) => e.classList.add('hidden'));
    if (this.options.onChange && triggerOnChange) this.options.onChange(CURRENCY_USD);
  }

  toUAH(triggerOnChange) {
    this.setCurrencyNodes();
    this.uah.forEach((e) => e.classList.remove('hidden'));
    this.usd.forEach((e) => e.classList.add('hidden'));
    if (this.options.onChange && triggerOnChange) this.options.onChange(CURRENCY_UAH);
  }

  updateTriggers(currentCurrency) {
    document.querySelectorAll(TOGGLE_CHIP_SELECTOR).forEach((input) => {
      const container = input.closest('[data-toggle-chip]');
      const chips = [...container.querySelectorAll('[data-toggle-chip-item]')];
      const activeChip = container.querySelector(`[data-toggle-chip-id="${currentCurrency}"]`);

      chips.forEach(chip => chip.classList.remove('-active'));
      input.value = currentCurrency;
      activeChip.classList.add('-active');
    });

    document.querySelectorAll(CHECKBOX_SELECTOR).forEach((switcher) => {
      switcher.checked = currentCurrency === CURRENCY_USD;
    });
  };
}

export default CurrencySwitcher;
